export default __webpack_public_path__ + "static/ploter-e8e7b3d04129eed0ff360f8060ecc0ac.png";